export enum MenuDefinitionTranslationKey {
    STRUCTURES = "menuDefinition.structures",
    ELEMENTS = "menuDefinition.elements",
    DIAGRAMS = "menuDefinition.diagrams",
    TOOLS = "menuDefinition.tools",
    ADMINISTRATION = "menuDefinition.administration",
}